import AuthorizationStore from '../../common_components/authorization/AuthorizationStore';
import {
  SHOW_BUSINESS_ALLOWED_ROLES,
  EDIT_BUSINESS_ALLOWED_ROLES,
} from '../../common_components/authorization/allowed_roles';
import { STARTUP_ROLES } from '../../common_components/authorization/constants';

export default class Authorization extends AuthorizationStore {
  constructor(rootStore, currentUserPermission) {
    super(rootStore, currentUserPermission);
  }

  get canEdit() {
    return this.canUpdate
            && (
              (this.rootStore.igBusinessStore)
                || (
                  !this.rootStore.isBmcVision
                    // this.rootStore.belongsToCurrentMvp &&
                    && this.rootStore.blankSlateMode
                )
                || (
                  this.rootStore.isBmcVision
                    && this.rootStore.thinkingMode.active
                    && this.rootStore.thinkingMode.atBmcVision
                )
                || (
                  !this.rootStore.isBmcVision // &&
              // this.rootStore.belongsToCurrentMvp &&
              // !this.rootStore.blankSlateMode
                )
            );
  }

  get canEditStage() {
    return this.canUpdate;
  }

  canDeleteCard(card) {
    return card
            && card.creator
            && this.rootStore.user.id === card.creator.id
            || this.authorizationApi([STARTUP_ROLES.CEO, STARTUP_ROLES.CO_FOUNDER])(this.rootStore);
  }


  get canShowOptions() {
    return !this.rootStore.isBmcVision;
  }

  get canRedirectToStepByStep() {
    return this.canEdit
            && this.rootStore.emptyBlocks
            && !this.rootStore.closeStepByStepMode;
  }
}
